module.exports = __webpack_public_path__ + "static/media/spaceship.6db09582.png";